import {
    CellFilterCondition,
    DateFilterCondition,
    FilterCondition,
    NumberFilterCondition,
    TextFilterCondition,
  } from '../../types';
  
  export const isTextlessFilter = (condition: FilterCondition) =>
    condition === CellFilterCondition.IsEmpty ||
    condition === CellFilterCondition.IsNotEmpty ||
    // condition === CellFilterCondition.ContainsFiles ||
    condition === CellFilterCondition.IsEdited ||
    condition === TextFilterCondition.TextIsValidURL ||
    condition === TextFilterCondition.TextIsValidEmail ||
    condition === DateFilterCondition.IsValid;
  
  export const isNumberRangeInputFilter = (condition: FilterCondition) =>
    condition === NumberFilterCondition.IsBetween ||
    condition === NumberFilterCondition.IsNotBetween;
  
  export const isDateRangeInputFilter = (condition: FilterCondition) =>
    condition === DateFilterCondition.IsBetween ||
    condition === DateFilterCondition.IsNotBetween;
  
  export const isDateInputFilter = (condition: FilterCondition) => {
    if (
      condition === CellFilterCondition.EditedBefore ||
      condition === CellFilterCondition.EditedOn
    )
      return true;
  
    const values: string[] = Object.values(DateFilterCondition);
  
    return values.includes(condition);
  };
  
  export const isTextInputFilter = (condition: FilterCondition) => {
    if (condition === CellFilterCondition.LastEditedBy) return true;
    const values: string[] = Object.values(TextFilterCondition);
    return values.includes(condition);
  };
  